import { render, staticRenderFns } from "./register-button.vue?vue&type=template&id=ef080474&scoped=true&"
import script from "./register-button.vue?vue&type=script&lang=js&"
export * from "./register-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef080474",
  null
  
)

export default component.exports